const titanPremiumCycles = {
  ANNUALLY: 'annually',
  SEMIANNUALLY: 'semiannually',
  QUARTERLY: 'quarterly',
  MONTHLY: 'monthly',
};

export default titanPremiumCycles;
